import { React, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ZeroOneKLessons } from "../modules/ZeroOneKLessons";
import { OneTwoKLessons } from "../modules/OneTwoKLessons";
import { TwoThreeKLessons } from "../modules/TwoThreeKLessons";
import { ThreeFourKLessons } from "../modules/ThreeFourKLessons";
import { FourFiveKLessons } from "../modules/FourFiveKLessons";
import { FiveSixKLessons } from "../modules/FiveSixKLessons";

export default function Lesson({ lesson, lessonBand, lessonCode, mainArray }) {
  const [selectedWord, setSelectedWord] = useState("");

  const [showText, setShowText] = useState(false);
  const [showTest, setShowTest] = useState(true);

  const wordIndexes = Array.from({ length: 50 }, (_, i) => i + 1);

  function action(i) {
    const koreanWord = lesson[`KoreanWord${i}`];
    const english = lesson[`KoreanWord${i}EngTranslation`];

    setSelectedWord({
      korean: koreanWord,
      english: english,
    });
  }

  return (
    <Container>
      <Row>
        <Col className="pt-3">
          {lesson.lessonNumber - 1 < 1 ? (
            <Button
              variant="outline-secondary"
              size="sm"
              className="lessonSelectButtons text-decoration-none"
              disabled
            >
              &lt; Previous
            </Button>
          ) : (
            <Link
              className="nextPrevLink"
              to={`/${lessonCode}klesson${lesson.lessonNumber - 1}`}
            >
              <Button
                variant="outline-secondary"
                size="sm"
                className="lessonSelectButtons"
              >
                &lt; Previous
              </Button>
            </Link>
          )}

          <Link to="/" className="text-decoration-none d-inline mx-2">
            <Button variant="outline-secondary" size="sm">
              Return to Index
            </Button>
          </Link>

          {lesson.lessonNumber + 1 > mainArray.length ? (
            <Button
              variant="outline-secondary"
              size="sm"
              className="text-decoration-none"
              disabled
            >
              Next &gt;
            </Button>
          ) : (
            <Link to={`/${lessonCode}klesson${lesson.lessonNumber + 1}`}>
              <Button
                variant="outline-secondary"
                size="sm"
                className="lessonSelectButtons"
              >
                Next &gt;
              </Button>
            </Link>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-secondary mt-2 mb-1">{lessonBand}</p>
          <h4 className="mb-3">
            {lesson.lessonNumber}. {lesson.lessonTitle}
          </h4>
          <Button
            variant={showText ? "danger" : "success"}
            onClick={() => {
              setShowText(!showText);
              setShowTest(!showTest);
            }}
          >
            {showText ? "Test yourself" : "Show hints"}
          </Button>
          <div className="mb-4"></div>

          {showText && (
            <>
              {wordIndexes.map((i) => {
                const korean = lesson[`KoreanWord${i}`];
                const pre = lesson[`PreKoreanWord${i}`];
                const post = lesson[`PostKoreanWord${i}`];

                return (
                  <p key={i}>
                    {pre}{" "}
                    <Button
                      variant="outline-secondary"
                      size="lg"
                      className="m-1"
                      onClick={() => action(i)}
                    >
                      {korean}
                    </Button>{" "}
                    {post}
                  </p>
                );
              })}
            </>
          )}

          {showTest && (
            <>
              {wordIndexes.map((i) => {
                const korean = lesson[`KoreanWord${i}`];

                return (
                  <p key={i} className="d-inline">
                    <Button
                      variant="outline-secondary"
                      size="lg"
                      className="m-1"
                      onClick={() => action(i)}
                    >
                      {korean}
                    </Button>{" "}
                  </p>
                );
              })}
            </>
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Button
            variant={showText ? "danger" : "success"}
            onClick={() => {
              setShowText(!showText);
              setShowTest(!showTest);
            }}
          >
            {showText ? "Test yourself" : "Show hints"}
          </Button>
          <p className="text-secondary mt-2 mb-1">{lessonBand}</p>
        </Col>
      </Row>
      <Row>
        <Col className="pt-2">
          {lesson.lessonNumber - 1 < 1 ? (
            <Button
              variant="outline-secondary"
              size="sm"
              className="lessonSelectButtons text-decoration-none"
              disabled
            >
              &lt; Previous
            </Button>
          ) : (
            <Link
              className="nextPrevLink"
              to={`/${lessonCode}klesson${lesson.lessonNumber - 1}`}
            >
              <Button
                variant="outline-secondary"
                size="sm"
                className="lessonSelectButtons"
              >
                &lt; Previous
              </Button>
            </Link>
          )}

          <Link to="/" className="text-decoration-none d-inline mx-2">
            <Button variant="outline-secondary" size="sm">
              Return to Index
            </Button>
          </Link>

          {lesson.lessonNumber + 1 > mainArray.length ? (
            <Button
              variant="outline-secondary"
              size="sm"
              className="text-decoration-none"
              disabled
            >
              Next &gt;
            </Button>
          ) : (
            <Link to={`/${lessonCode}klesson${lesson.lessonNumber + 1}`}>
              <Button
                variant="outline-secondary"
                size="sm"
                className="lessonSelectButtons"
              >
                Next &gt;
              </Button>
            </Link>
          )}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          {lesson.lessonNumber + 1 > mainArray.length &&
            lessonCode !== "56" && (
              <Link
                className="nextPrevLink"
                to={`/${parseInt(lessonCode) + 11}klesson1`}
              >
                <Button variant="outline-success">
                  Next frequency band lesson 1
                </Button>
              </Link>
            )}
          {lesson.lessonNumber - 1 < 1 &&
            lessonCode !== "01" &&
            lessonCode !== "12" && (
              <Link
                className="nextPrevLink"
                to={`/${parseInt(lessonCode) - 11}klesson1`}
              >
                <Button variant="outline-warning">
                  Previous frequency band lesson 1
                </Button>
              </Link>
            )}
          {lesson.lessonNumber - 1 < 1 && lessonCode === "12" && (
            <Link className="nextPrevLink" to="/01klesson1">
              <Button variant="outline-warning">
                Previous frequency band lesson 1
              </Button>
            </Link>
          )}
        </Col>
      </Row>
      <Row className="my-5"></Row>
      <Row className="my-5"></Row>
      <Row className="my-5"></Row>
      <Container className="bg-white fixed-bottom border py-3">
        <Row>
          <Col>
            <div className="d-flex align-items-center mb-1">
              <p className="mb-0 me-2 fs-4 fw-lighter bg-danger bg-opacity-10 px-3 rounded">
                Korean:
              </p>
              <p className="mb-0 fs-4">{selectedWord.korean}</p>
            </div>
            <div className="d-flex align-items-center">
              <p className="mb-0 me-2 fs-4 fw-lighter bg-info bg-opacity-10 px-3 rounded">
                English:
              </p>
              <p className="mb-0 fs-4">{selectedWord.english}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
